import React from 'react'
import CustomTable from "../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axiosInstanceMainUrl from '../utils/axiosInstanceMainUrl';
import { Switch, Box, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
// import React, { useState } from 'react'
// import {useSelector} from 'react'
import Button from '@mui/material/Button'
import MuiSelectionModal from '../components/muiselectionmodal/MuiSelectionModal';
// import { from } from 'core-js/core/array';


function KycNameMismatch() {

    const [stateResponse, setStateResponse] = useState([]);
    const [open, setOpen] = useState(false)
    const [status, setStatus] = useState('')
    const [stateLoading, setStateLoading] = useState(true);
    const [formData, setFormData] = useState({
        id: "",
        status: "",
    });
    const roleResponse = useSelector((state) => state.login.login.role);
    const getlistofusers = async () => {
        try {
            const url = `/api/admin/getNameMismatchUsers`;
            const response = await axiosInstanceMainUrl.get(url,
                // {
                //     headers: {   
                //         "Content-Type": "application/json",
                //         Accept: "application/json",
                //         Authorization: `Bearer ${token}`,
                //     },
                // }    
            );
            if (response.data.error == false) {
                setStateResponse(response.data.data);
                setStateLoading(false);
            } else {
                setStateResponse([]);
                setStateLoading(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setStateResponse([]);
            setStateLoading(false);
        }
    };


    // const handleStatusChange = async (id) => {
    //     try {
    //         const url = `/templateToggle/${id}`;
    //         // const url = `${baseUrl}/templateToggle/${id}`;
    //         const response = await axiosInstance.put(url, {},
    //             //     {
    //             //     headers: {
    //             //         "Content-Type": "application/json",
    //             //         Accept: "application/json",
    //             //         Authorization: `Bearer ${token}`,
    //             //     },
    //             // }
    //         );
    //         // const response = await axios.put(url, {}, {
    //         //     headers: {
    //         //         "Content-Type": "application/json",
    //         //         Accept: "application/json",
    //         //         Authorization: `Bearer ${token}`,
    //         //     },
    //         // });
    //         if (response.data.error == false) {
    //             Swal.fire({
    //                 text: "Status Updated Successfully!",
    //                 icon: "success",
    //                 timer: 2000,
    //                 showConfirmButton: false,
    //             });
    //             // toast.success(response.data.message);
    //             dispatch(getAllTemplateApi());

    //         } else {
    //             Swal.fire({
    //                 text: "Failed to update status",
    //                 icon: "error",
    //                 timer: 2000,
    //                 showConfirmButton: false,
    //             });
    //             // toast.error(response.data.message);
    //         }

    //     } catch (error) {
    //         console.error("Error updating status:", error);
    //         Swal.fire({
    //             text: "Failed to update status",
    //             icon: "error",
    //             timer: 2000,
    //             showConfirmButton: false,
    //         });
    //         //   toast.error("Failed to update status");
    //     }
    // };

    useEffect(() => {
        getlistofusers();
    }, []);

    const columnHelper = createMRTColumnHelper();
    const columns = [
        columnHelper.accessor("customerRefNo", {
            header: "Customer Ref No",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell.row.original?.customerRefNo);
                    toast.success("Copied to clipboard!");
                };
                return (
                    <Tooltip title={cell.row.original?.customerRefNo}>
                        <span>
                            <IconButton onClick={handleCopy}>
                                <ContentCopy />
                            </IconButton>
                            {cell.row.original?.customerRefNo}
                        </span>
                    </Tooltip>
                )
            },
        }),
        columnHelper.accessor("name", {
            header: "Name",
            size: 30,
        }),

        columnHelper.accessor("reason", {
            header: "Reason",
            size: 30,
        }),
        columnHelper.accessor("refinery", {
            header: "Refinery",
            size: 30,
        }),
        columnHelper.accessor("type", {
            header: "Type",
            size: 30,
        }),
        columnHelper.accessor("status", {
            header: "Status",
            size: 30,
        }),

        columnHelper.accessor("createdAt", {
            header: "Created At",
            size: 30,
            Cell: (cell) => (
                <span style={{ textAlign: "center" }}>
                    {cell.row.original.createdAt.split("T")[0]}
                </span>
            ),
        }),
        columnHelper.accessor("updatedAt", {
            header: "Updated At",
            size: 30,
            Cell: (cell) => (
                <span style={{ textAlign: "center" }}>
                    {cell.row.original.updatedAt.split("T")[0]}
                </span>
            ),
        }),
    ];
    if (roleResponse?.kycmismatch?.update === 1) {
        columns.push(
            columnHelper.accessor("Actions", {
                header: "Status Update",
                size: 30,
                Cell: ({ cell }) => {
                    const rowId = cell.row.original._id;
                    const rowData = cell.row.original;

                    return (
                        <Box>
                            {roleResponse?.kycmismatch?.update === 1 && (
                                <Tooltip title="Edit">
                                    <IconButton
                                        onClick={() => {
                                            setOpen(true)
                                            setFormData({
                                                id: rowId || "",

                                            });
                                            document.getElementById("file-input").value = "";

                                            window.scrollTo({
                                                top: 0,
                                                behavior: "smooth",
                                            });

                                        }}
                                    >
                                        <EditIcon color="error" />
                                    </IconButton>
                                </Tooltip>
                            )}

                        </Box>
                    );
                },
            })
        );

    //    columns.push(
    //         columnHelper.accessor("Actions", {
    //         header: "Actions",
    //         Cell: ({ row }) => {
    //             const status = row.original.status?.toLowerCase();

    //             const isEditable = status === "open" || status === "processing";
    //             return (
    //                 <Box>
    //                     <Tooltip title={isEditable ? "Edit" : "Cannot Edit"}>
    //                         <span>
    //                             <IconButton
                                   
    //                                 onClick={() => {
    //                                     if (!isEditable) return;

    //                                     setOpen(true);
    //                                     setFormData({
    //                                         customerRefNo: row.original?.customerRefNo || "",
    //                                     });
    //                                 }}
    //                                 sx={{
    //                                     color: isEditable ? "primary.main" : "grey.400",
    //                                     opacity: isEditable ? 1 : 0.5,
    //                                 }}
    //                             >
    //                                 <EditIcon />
    //                             </IconButton>
    //                         </span>
    //                     </Tooltip>
    //                 </Box>
    //             );
    //         }
    //     }));
    }
    return (
        <>
            {open && (
                <MuiSelectionModal
                    open={open}
                    onClose={() => setOpen(false)}
                    value={status}
                    onChange={(val) => setStatus(val)}
                    formData={formData}
                    setFormData={setFormData}
                    getlistofusers={getlistofusers}
                />
            )}

            <CustomTable
                columns={columns}
                data={stateResponse}
                loading={stateLoading}
                permissionKey="kycmismatch"
            />
        </>
    );
}

export default KycNameMismatch